// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const GiftIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" {...props}>
		<defs>
			<linearGradient x1="0%" y1="0%" x2="96.481%" y2="96.481%" id="GiftIcon_tsx__a">
				<stop stopColor="#9191FF" offset="0%" />
				<stop stopColor="#F075C7" offset="100%" />
			</linearGradient>
		</defs>
		<g fill="none" fillRule="evenodd">
			<circle fill="url(#GiftIcon_tsx__a)" cx={32} cy={32} r={32} />
			<path
				d="M35.751 23.06c1.288-.482 3.133-1.744 2.942-3.244-.09-.72-.663-1.408-1.423-1.713a2.269 2.269 0 0 0-.85-.165c-.607 0-1.228.241-1.81.713-1.363 1.104-1.779 3.44-1.86 5.013.005.112.008.219.01.318.603-.13 1.575-.392 2.991-.922Zm-4.502.657c-.066-1.427-.398-3.882-1.859-5.066-.582-.472-1.203-.713-1.81-.713-.288 0-.574.054-.85.165-.76.305-1.332.993-1.424 1.713-.19 1.5 1.656 2.762 2.943 3.244 1.416.53 2.388.793 2.99.922.003-.084.005-.173.01-.265Zm13.535 1.781v3.833c0 .766-.678 1.39-1.511 1.39H20.727c-.834 0-1.512-.624-1.512-1.39v-3.833c0-.766.678-1.39 1.511-1.39h6.183c-1.818-.917-3.338-2.54-3.091-4.482.16-1.262 1.084-2.406 2.353-2.915 1.363-.547 2.88-.264 4.163.775.774.627 1.303 1.48 1.665 2.384.362-.904.891-1.757 1.665-2.384 1.283-1.04 2.8-1.322 4.164-.775 1.269.51 2.192 1.654 2.352 2.915.248 1.942-1.273 3.565-3.09 4.482h6.181c.834 0 1.512.624 1.512 1.39Zm-1.807 6.723v12.326c0 .835-.677 1.515-1.509 1.515H22.532c-.832 0-1.509-.68-1.509-1.515V32.22h21.954Z"
				fill="#FFF"
			/>
		</g>
	</svg>
);
export default GiftIcon;
